export const userRoles = {
  CITIZEN: 'Citizen',
  STORE_OWNER: 'StoreOwner',
  DRIVER: 'Driver',
  INDIVIDUAL: 'individual',
  ENTERPRISE: 'enterprise',
  HIJACK: 'hijack',
}
